import React from 'react';
import { ctw } from '@/common/utils/ctw';

export const TableCaption = React.forwardRef<
  HTMLTableCaptionElement,
  React.HTMLAttributes<HTMLTableCaptionElement>
>(({ className, ...props }, ref) => (
  <caption ref={ref} className={ctw('text-muted-foreground mt-4 text-sm', className)} {...props} />
));

TableCaption.displayName = 'TableCaption';
